import { Textarea, TextInput } from '@mantine/core';

interface TextOverrideFieldProps {
  label: string;
  value: string | null;
  inheritedText: string;
  multiline: boolean;
  changed: boolean;
  onChange: (value: string | null) => void;
}

export function TextOverrideField({
  label,
  value,
  inheritedText,
  multiline,
  changed,
  onChange,
}: TextOverrideFieldProps) {
  const commonProps = {
    label: changed ? `${label} (unsaved)` : label,
    value: value ?? '',
    placeholder: inheritedText,
    description: 'Leave empty to inherit',
    size: 'xs' as const,
  };
  return multiline ? (
    <Textarea
      {...commonProps}
      autosize
      minRows={1}
      maxRows={6}
      onChange={(event) =>
        onChange(event.currentTarget.value.trim() ? event.currentTarget.value : null)
      }
    />
  ) : (
    <TextInput
      {...commonProps}
      onChange={(event) =>
        onChange(event.currentTarget.value.trim() ? event.currentTarget.value : null)
      }
    />
  );
}
